import api from "./api";

export const apiGetStatesByCountryId = async (country_id) => {
  return await api.get(`/api/location_db/states/${country_id}`);
};

export const getStateList = async (data) => {
  return await api.post(`/api/location_db/state_list`, data);
};
